import React from 'react'
import { getNameByField } from './Utils'
import { Stack } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Setup } from '../../../models/interfaces/setup.interface'

type Props = {
  setup?: Setup[]
  onPress: () => void
}

export const Summary = ({ setup, onPress }: Props) => {
  const { palette } = useTheme()
  return (
    <>
      <Stack
        onClick={onPress}
        flexDirection="row"
        alignItems="center"
        p={1}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          {setup?.map((item, key: number) => {
            return (
              <Stack flexDirection="row" justifyContent={{ xs: 'left', sm: 'center' }} alignItems="center" key={key} flexWrap={'wrap'}>
                <span style={{ color: palette.grey[500], fontSize: 15 }}>{getNameByField(item.field)}:</span>
                <span style={{ color: palette.grey[200], fontSize: 15, marginLeft: 2 }}>{item.value}</span>
              </Stack>
            )
          })}
        </Stack>
      </Stack>
    </>
  )
}
